export default __webpack_public_path__ + "candidate.03ad145.png";